import type { RoomBookingKind } from '@/api/types'

/**
 * Powody zajęcia sali poza zajęciami.
 *
 * Zamknięta lista, a nie dowolny tekst: po powodzie da się potem policzyć, ile
 * czasu sala stała na remoncie, a ile na spotkaniach. Miejsce na szczegóły jest
 * w notatce — przy powodzie „inne” serwer jej wręcz wymaga.
 */
export const ETYKIETY_REZERWACJI: Record<RoomBookingKind, string> = {
  MEETING: 'Spotkanie',
  MAINTENANCE: 'Remont lub przegląd',
  RECORDING: 'Nagranie',
  OTHER: 'Inne',
}

export const RODZAJE_REZERWACJI = Object.entries(ETYKIETY_REZERWACJI) as [RoomBookingKind, string][]
